import { render, staticRenderFns } from "./ArchivedPrivacy.vue?vue&type=template&id=0e34075c&scoped=true&"
import script from "./ArchivedPrivacy.vue?vue&type=script&lang=js&"
export * from "./ArchivedPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedPrivacy.vue?vue&type=style&index=0&id=0e34075c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34075c",
  null
  
)

export default component.exports